import { Box, CircularProgress } from "@mui/material";

export default function Loading() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="60vh" // centers vertically
    >
      <CircularProgress size={60} /> {/* you can adjust the size */}
    </Box>
  );
}
